export const LIVE_PREVIEW_EDITOR_SOURCE = 'live-preview-editor' as const;
export const LIVE_PREVIEW_SDK_SOURCE = 'live-preview-sdk' as const;
